import { CSSProperties, FC } from 'react';
import { useStyles } from './useStyles';
import { Box, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

type IWidgetContainerProps = {
  children: JSX.Element | JSX.Element[];
  style?: CSSProperties | undefined;
  className?: SxProps<Theme>;
};

const WidgetContainer: FC<IWidgetContainerProps> = ({
  children,
  style,
  className,
}) => {
  const classes = useStyles();
  const myStyles = {
    ...classes.root,
    ...className,
    ...style,
  } as SystemStyleObject;
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <Box sx={myStyles}>{children}</Box>
  );
};

export default WidgetContainer;
